export default "/images/error.svg?47827806c07b033548de03533e43e702";